@if (rootModel()) {
<div class="client-tree">
    <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'" [style.top]="menuPosition.y + 'px'"></span>
    <app-client-node [model]="rootModel()"></app-client-node>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-component="component" let-menu="menu">
        <button mat-menu-item [disabled]="!menu.club" (click)="onClub()">
          <mat-icon>group_add</mat-icon>
          <span>New Club</span>
        </button>
        <button mat-menu-item [disabled]="!menu.client" (click)="onClient()">
          <mat-icon>enhanced_encryption</mat-icon>
          <span>Add Client</span>
        </button>
        <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
          <mat-icon>close</mat-icon>
          <span>Delete</span>
        </button>
        <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
          <mat-icon>flip_to_front</mat-icon>
          <span>Cut</span>
        </button>
        <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
          <mat-icon>flip_to_back</mat-icon>
          <span>Copy</span>
        </button>
        <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
          <mat-icon>library_add</mat-icon>
          <span>Paste</span>
        </button>
      </ng-template>
    </mat-menu>
  </div>
}
